// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { convertBetweenMandFt } from 'helpers/unitConversion'
import { valueIsInArray } from 'helpers/reduxFormFunctions'
import { MUST_SEARCH_AT_LEAST_ONE_VALUE } from 'errors'
import {
  assembleQuery,
  fetchAntennaSpecsByQuery,
  makePaginationParams,
} from 'helpers/api'

const parseAsFloat = [
  'adv-antennaApplicationId',
  'adv-beamwidth',
  'adv-classificationId',
  'adv-complianceId',
  'adv-diameter',
  'adv-gain',
  'adv-rpeNumber',
  'adv-statusId',
  'frequency',
]

const eqList = [
  'adv-antennaApplicationId',
  'adv-beamwidth',
  'adv-classificationId',
  'adv-complianceId',
  'adv-gain',
  'adv-statusId',
]

// if it's in the list, cast this unit to number
const castValueType = (k, v) => valueIsInArray(v, parseAsFloat) ? parseFloat(v) : v

// if it's in the list, then give it an EQ operator
const setOperator = f => valueIsInArray(f, eqList) ? 'EQ' : 'LIKE'

const fetchData = formArgs => {
  const {
    formProps,
    formValues,
    queryBasis = [],
    includeFlags = [],
    submittedFormIsPristine,
  } = formArgs

  const d = { ...formValues }

  // if it's 'none', then simply don't include it in the query.
  if (d.feedDir === '') {
    delete d.feedDir
  } else {
    d.feedDir = (
      d.feedDir[0] === 'R'
        ? 'Right Feed'
        : 'Left Feed'
    )
  }

  // API assumes diameter is in meters. convert from feet if necessary
  if (d['adv-diameter'].length && d['adv-diameterUnit'] === 'US') {
    d['adv-diameter'] = convertBetweenMandFt(d['adv-diameter'], 'SI')
  }
  // we don't want to pass this as a field in the search query
  delete d['adv-diameterUnit']

  // form must have at least one value
  // throws error message if false
  const search = [...queryBasis]

  // advanced search input fields should be ignored
  // if the advanced search section isn't displayed.
  const isAdvSearch = !!d.advancedSearch.length
  delete d.advancedSearch

  // captured to ensure queryies are not made without any search values.
  let hasValue = false

  Object.keys(d).forEach(k => {
    // ignore pagination values when building the search query
    if (k === 'pagination') {
      return
    }

    const isAdvInput = k.indexOf('adv-') === 0
    // do not consider 'hasValue' for advanced input
    // values if it is not an advanced search
    if (!hasValue && d[k].toString().length &&
      (isAdvSearch && isAdvInput || !isAdvInput)) {
      hasValue = true
    }

    // don't send advanced input values in the query
    // when it's not not an advanced search
    if (d[k] !== undefined && d[k].toString().length &&
      (isAdvSearch && isAdvInput || !isAdvInput)) {
      search.push({
        value: castValueType(k, d[k]),
        field: isAdvInput ? k.slice(4) : k,
        operator: setOperator(k),
      })
    }
  })

  // don't perform search if there are no values defined.
  if (!hasValue) {
    throw new Error(MUST_SEARCH_AT_LEAST_ONE_VALUE)
  }

  const page = (
    formValues.pagination && submittedFormIsPristine(formProps.form)
      ? +formValues.pagination.page
      : 0
  )

  // size of results set in API response - default to 500 count
  const size = 500

  const paginationParams = makePaginationParams({
    page,
    size,
  })

  const searchQuery = {
    field: 'search',
    value: [search],
  }

  const query = [
    searchQuery,
    ...includeFlags,
    ...paginationParams,
  ]

  return fetchAntennaSpecsByQuery(assembleQuery(query))
}

export default fetchData
